export default "__VITE_ASSET__9f77d78f__"